import React from 'react';
import { getValueOrDefault } from '../../../utils/ModalUtils';

/**
 * props:
 * - data (orderTemplate)
 * - onChange
 */
function PartialTpTemplate({ data, onChange }) {
    const hasAnyTp = data.tp1Percent > 0 || data.tp2Percent > 0 || data.tp3Trailing;

    function onCheckChange(event) {
        onChange({ target: { id: event.target.id, value: event.target.checked } });
    }

    return (
        <div className="row mb-3">
            <div className="col-12">
                <div className="card border-secondary">
                    <div className="card-header py-2 d-flex align-items-center gap-3">
                        <strong className="me-2">Take Profit Parcial</strong>
                        <div className="form-check form-check-inline mb-0">
                            <input className="form-check-input" type="checkbox" id="moveStopOnTp1"
                                checked={!!data.moveStopOnTp1} onChange={onCheckChange} />
                            <label className="form-check-label small" htmlFor="moveStopOnTp1">Mover stop para breakeven no TP1</label>
                        </div>
                    </div>
                    {hasAnyTp && (
                        <div className="card-body py-2 small text-muted">
                            A quantidade restante após TP1 + TP2 é vendida no TP3 (trailing ou mercado).
                        </div>
                    )}
                    <div className="card-body pt-0">
                        <div className="row g-2 align-items-end">
                            {/* TP1 */}
                            <div className="col-md-3">
                                <label htmlFor="tp1Percent" className="form-label small mb-1">TP1 em (%)</label>
                                <input type="number" className="form-control form-control-sm" id="tp1Percent"
                                    min="0" step="0.1" placeholder="e.g. 1.5"
                                    value={getValueOrDefault(data.tp1Percent, '')}
                                    onChange={onChange} />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="tp1Quantity" className="form-label small mb-1">Qtd vender no TP1 (%)</label>
                                <input type="number" className="form-control form-control-sm" id="tp1Quantity"
                                    min="1" max="100" step="1" placeholder="e.g. 33"
                                    value={getValueOrDefault(data.tp1Quantity, '')}
                                    onChange={onChange} />
                            </div>
                            {/* TP2 */}
                            <div className="col-md-3">
                                <label htmlFor="tp2Percent" className="form-label small mb-1">TP2 em (%)</label>
                                <input type="number" className="form-control form-control-sm" id="tp2Percent"
                                    min="0" step="0.1" placeholder="e.g. 3.0"
                                    value={getValueOrDefault(data.tp2Percent, '')}
                                    onChange={onChange} />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="tp2Quantity" className="form-label small mb-1">Qtd vender no TP2 (%)</label>
                                <input type="number" className="form-control form-control-sm" id="tp2Quantity"
                                    min="1" max="100" step="1" placeholder="e.g. 33"
                                    value={getValueOrDefault(data.tp2Quantity, '')}
                                    onChange={onChange} />
                            </div>
                        </div>

                        <div className="row g-2 align-items-end mt-1">
                            {/* TP3 trailing */}
                            <div className="col-md-3 d-flex align-items-center">
                                <div className="form-check mb-0">
                                    <input className="form-check-input" type="checkbox" id="tp3Trailing"
                                        checked={!!data.tp3Trailing} onChange={onCheckChange} />
                                    <label className="form-check-label small" htmlFor="tp3Trailing">TP3 trailing stop</label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="tp3TrailingStop" className="form-label small mb-1">
                                    Retorno fixo (%)
                                    <span className="text-muted ms-1" style={{fontSize:'0.7em'}}>usado se ATR não definido</span>
                                </label>
                                <input type="number" className="form-control form-control-sm" id="tp3TrailingStop"
                                    min="0.1" step="0.1" placeholder="e.g. 1.0"
                                    disabled={!data.tp3Trailing}
                                    value={getValueOrDefault(data.tp3TrailingStop, '')}
                                    onChange={onChange} />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="tp3AtrMultiplier" className="form-label small mb-1">
                                    Multiplicador ATR
                                    <span className="text-muted ms-1" style={{fontSize:'0.7em'}}>sobrepõe o % fixo</span>
                                </label>
                                <input type="number" className="form-control form-control-sm" id="tp3AtrMultiplier"
                                    min="0.1" step="0.1" placeholder="e.g. 2.0"
                                    disabled={!data.tp3Trailing}
                                    value={getValueOrDefault(data.tp3AtrMultiplier, '')}
                                    onChange={onChange} />
                            </div>
                        </div>
                        {data.tp3Trailing && data.tp3AtrMultiplier > 0 && (
                            <div className="row mt-1">
                                <div className="col-12">
                                    <small className="text-info">ATR trailing ativo: distância de trailing = {data.tp3AtrMultiplier}× ATR(14). Requer um monitor ATR em execução neste símbolo.</small>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PartialTpTemplate;
